import { Box, Typography, Divider } from "@mui/material";
import theme from "../../../../../theme";
import {
  SPACING,
  BODY_SPACING,
} from "../../../../../utils/constants/designConstants";
import { isDataEmpty } from "../../../../../utils/functions";
import { CopyTextButton } from "../../CopyButton";
import {
  PFFContentSection,
  PFFFurtherReading,
  PFF_CONTENT_OFFSET,
  PFFMetricsSection,
} from "./index";

const ContentBoxWithPadding = ({ children }) => (
  <div
    className="generate-insights-content-inside-box"
    style={{ padding: "2rem 0" }}
  >
    {children}
  </div>
);

export const PFFReusableComponent = ({ porterFiveForces }) => {
  const porterFiveForcesContent = porterFiveForces?.analysis || {
    sections: [],
    furtherReading: [],
  };

  return (
    <ContentBoxWithPadding>
      <Box
        className="generate-insights-content-inside-box"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          py: 2.5,
          mb: SPACING.SUBHEADING_BOTTOM,
        }}
      >
        <Typography
          variant="h2"
          component="h2"
          sx={{
            color: "primary.white",
          }}
        >
          Porter's Five Forces
        </Typography>
        {(!isDataEmpty(porterFiveForces?.metrics) ||
          !isDataEmpty(porterFiveForcesContent?.sections) ||
          !isDataEmpty(porterFiveForcesContent?.furtherReading)) && (
          <CopyTextButton
            textToCopy={porterFiveForcesContent || porterFiveForces}
            sectionTitle="Porter's Five Forces"
          />
        )}
      </Box>
      {isDataEmpty(porterFiveForces?.metrics) &&
      isDataEmpty(porterFiveForcesContent?.sections) &&
      isDataEmpty(porterFiveForcesContent?.furtherReading) ? (
        <Typography
          variant="body2"
          sx={{
            color: "primary.white",
            py: BODY_SPACING.ERROR_MESSAGE_SECTION_PADDING,
            mb: BODY_SPACING.ERROR_MESSAGE_SECTION_MARGIN_BOTTOM,
          }}
        >
          Porter's Five Forces aren't available at the moment.
        </Typography>
      ) : (
        <>
          {porterFiveForces?.metrics &&
            !isDataEmpty(porterFiveForces.metrics) && (
              <PFFMetricsSection porterFiveForces={porterFiveForces} />
            )}

          {porterFiveForcesContent?.sections?.length > 0 && (
            <Box>
              {porterFiveForcesContent.sections.map((section, sectionIndex) => (
                <PFFContentSection
                  key={sectionIndex}
                  section={section}
                  offset={PFF_CONTENT_OFFSET[sectionIndex]}
                />
              ))}
            </Box>
          )}

          {porterFiveForcesContent?.furtherReading?.length > 0 && (
            <>
              <Divider
                sx={{
                  border: `1px solid ${theme.palette.primary.brandMain}`,
                  mb: 2,
                }}
              />
              <PFFFurtherReading
                furtherReading={porterFiveForcesContent.furtherReading}
              />
            </>
          )}
        </>
      )}
    </ContentBoxWithPadding>
  );
};
